import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NavbarComponent } from './navbar-component/navbar.component';
import { ShowComponent } from './show-component/show.component';

@NgModule({
  declarations: [
      NavbarComponent,
      ShowComponent
  ],
  imports: [
    BrowserModule,
  ],
  providers: [],
  bootstrap: [],
  exports:[NavbarComponent,ShowComponent]
})
export class CoreModule { }
